import * as S from './styles'
import { useAdaptedProcesses } from './useAdaptedProcesses'
import { Image, Text } from '@/components'
import { AdaptedProcessProps } from '@/service/api/servicesPage'

export type AdaptedProcessesContainerProps = {
  data: AdaptedProcessProps
}
export const AdaptedProcessesContainer: React.FC<
  AdaptedProcessesContainerProps
> = ({ data }) => {
  const { fontSizes, responsive } = useAdaptedProcesses()

  return (
    <S.FlexContainerAdaptedProccess padding="0">
      <S.AdaptedProcessesContainer>
        <Text align="left" color="primary" size={fontSizes.title}>
          {data.title}
        </Text>
        <Text align="left" size={fontSizes.description}>
          {data.description}
        </Text>
        {data.topics.length > 0 && (
          <div className="topics">
            {data.topics.map((topic, index) => (
              <div key={topic.title} className="topic">
                {topic.icon?.url && (
                  <Image
                    src={topic.icon.url}
                    alt={topic.icon.alternativeText}
                    fileName={topic.icon.name}
                    responsiveSizes={{
                      700: {
                        height: 48,
                        width: 48,
                      },
                    }}
                  />
                )}
                <div className="topic-group">
                  <Text
                    align="center"
                    color="primary"
                    size={fontSizes.subtitle}
                  >
                    {index + 1}. {topic.title}
                  </Text>
                  <Text align="center" size={fontSizes.subDescription}>
                    {topic.description}
                  </Text>
                </div>
              </div>
            ))}
          </div>
        )}
      </S.AdaptedProcessesContainer>
      {data.technologies.length > 0 && (
        <S.TechnologiesContainer className="menu">
          <S.Slider
            responsive={responsive}
            autoPlaySpeed={1500}
            slidesToSlide={2}
          >
            {data.technologies.map((technology) => (
              <Image
                key={technology.name}
                src={technology.icon}
                alt={technology.name}
                defaultSize={{
                  height: 80,
                  width: 80,
                }}
              />
            ))}
          </S.Slider>
        </S.TechnologiesContainer>
      )}
    </S.FlexContainerAdaptedProccess>
  )
}
